import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'
import Label from 'LuxKit/Label'
import React from 'react'

interface Props {
  name: string
}

function MultiCartAddedByLabel({ name }: Props) {
  return <Label startIcon={<LineUserIcon />} kind="plain" variant="dark">
    Added by {name}
  </Label>
}

export default MultiCartAddedByLabel
